import React, { Fragment } from 'react';
import {  REACT_APP_GOOGLE_LOCATION_API_KEY } from 'Helpers/apiurl'

const GoogleMapMarker = (props = {}) => {
    const { latitude = 0, longitude = 0, children , nameColor , name , type } = props;
    const apiKey = REACT_APP_GOOGLE_LOCATION_API_KEY;
    const file_url = `https://maps.googleapis.com/maps/api/staticmap?center=${ latitude },${ longitude }&zoom=13&size=200x200&markers=color:red|${ latitude },${ longitude }&key=${ apiKey }`;
   
    return (
        <Fragment>
            <div className='attachment-block location'>
                 {type === 'groupchat' && (
                        <div
                        className='report-user-name'
                        style={ { color: nameColor } }
                        >
                        { name }
                        </div>
                    )}
                <a target='_blank' rel='noopener noreferrer' href={ `https://www.google.com/maps/?q=${ latitude },${ longitude }` }>
                    <img src={ file_url } alt='location-map' />
                </a>
                { children }
            </div>
        </Fragment>
    );
};

export default GoogleMapMarker;
